import React, { useId } from 'react';
import styles from './Toggle.module.css';

export default function Toggle({
  checked,
  onChange,
  disabled = false,
  size = 'md',
  label,
  description,
  ariaLabel,
  className = ''
}) {
  const id = useId();

  return (
    <label
      htmlFor={id}
      className={[
        styles.row,
        size === 'sm' ? styles.sizeSm : '',
        disabled ? styles.disabled : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {label || description ? (
        <span className={styles.text}>
          {label ? <span className={styles.label}>{label}</span> : null}
          {description ? <span className={styles.description}>{description}</span> : null}
        </span>
      ) : null}
      <span className={[styles.track, checked ? styles.trackOn : ''].join(' ')}>
        <input
          id={id}
          type="checkbox"
          checked={!!checked}
          onChange={(e) => !disabled && onChange && onChange(e.target.checked)}
          disabled={disabled}
          aria-label={ariaLabel || label}
          className={styles.input}
        />
        <span className={styles.handle} />
      </span>
    </label>
  );
}
